import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../../../constants/apiPath";
import axios from "axios";

const initialState = {
  isLoading: false,
  coupons: [],
};
const THUNK_METHODS = {
  COUPON_GET: "user/coupons",
};



export const getCoupons = createAsyncThunk(
  THUNK_METHODS.COUPON_GET,
  async (cartvalue, { rejectWithValue }) => {
    try {
      const {data} = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}${API.COUPON.GET}`,
        withCredentials: true,
        data : cartvalue
      });
      return data.coupons;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("SignUp failed");
    }
  }
);

export const couponSlice = createSlice({
  name: "coupon",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCoupons.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCoupons.fulfilled, (state, action) => {
      state.coupons = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getCoupons.rejected, (state) => {
      state.isLoading = false;
    });
  },
});
export const { } = couponSlice.actions;
